<template>
  <Teleport to="#header-progress-bar">
    <slot></slot>
  </Teleport>
</template>
